import axios from 'axios'

export default {
    get: () => axios.get(`/project`),
    save: formData => axios.put(`/project/edit`, formData),
    getSettings: () => axios.get(`project/settings`),
    editSettings: formData => axios.put(`/project/settings/edit`, formData),
    posterSync: () => axios.get(`/project/settings/poster_sync`)
}
